import { render } from "./resultTable.vue?vue&type=template&id=50fc7916"
import script from "./resultTable.vue?vue&type=script&lang=js"
export * from "./resultTable.vue?vue&type=script&lang=js"

import "./resultTable.vue?vue&type=style&index=0&id=50fc7916&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__